/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, OnInit } from '@angular/core';
import { constant } from 'lodash';
import { PAGE_ENVIRONMENT_PROVIDER, PageEnvironment, PageEnvironmentProvider } from './page-environment.interfaces';

export type ResponsivePageEnvironment = PageEnvironment;

export const createResponsivePageEnvironment = constant({ name: 'responsive' });

@Directive({
  selector: 'gh-responsive-env', // tslint:disable-line:directive-selector
  providers: [{ provide: PAGE_ENVIRONMENT_PROVIDER, useExisting: ResponsivePageEnvironmentDirective }],
})
export class ResponsivePageEnvironmentDirective implements OnInit, PageEnvironmentProvider {
  minWidth?: number;
  environment: PageEnvironment;

  ngOnInit(): void {
    this.environment = createResponsivePageEnvironment();
  }
}
